import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../../i18n/globalTranslations';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import CheckoutModule from '../../common/CheckoutModule';
import CheckoutCart from '../CheckoutCart';
import CheckoutEmptyCart from '../CheckoutEmptyCart';

const CheckoutCartModule = ({ checkoutStore, onOrderUpdate, orderNumber }) => {
  const { order } = checkoutStore;
  const { cartAlerts } = order;

  const updateOrder = (args) => {
    onOrderUpdate({ module: CheckoutPageModule.CART_MODULE, ...args });
  };

  const renderCart = () => {
    return (
      <CheckoutCart
        onOrderUpdate={updateOrder}
        emptyCart={<CheckoutEmptyCart />}
      />
    );
  };

  return (
    <CheckoutModule
      className="CheckoutCartModule"
      generalAlerts={cartAlerts.general}
      errorAlerts={cartAlerts.errors}
      title={<FormattedMessage {...globalTranslations.proceedToCartSentence} />}
      orderNumber={orderNumber}
      module={CheckoutPageModule.CART_MODULE}
    >
      {renderCart()}
    </CheckoutModule>
  );
};

CheckoutCartModule.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
  orderNumber: PropTypes.number.isRequired,
};

export default inject('checkoutStore')(observer(CheckoutCartModule));
